import React, { useEffect, useState, useRef } from "react";
import { IMG, LOGO } from "../../../assets";
import "./Footer.css";
// eslint-disable-next-line
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import MAP from "../../../assets/map.png";

const textAnimation = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1.1,
    transition: { duration: 1.2 },
  },
};

const mapAnimation = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 1 },
  },
};
const mapAnimation2 = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 1.2 },
  },
};

export default function Footer() {
  const [isVisible, setIsVisible] = useState(false);
  const [mapInViewRef, inView] = useInView({ threshold: 0.1 });
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  const social = [
    { id: 1, name: "linkedin", icon: IMG.IN },
    { id: 2, name: "twitter", icon: IMG.TW },
    { id: 3, name: "youtube", icon: IMG.YT },
    { id: 4, name: "facebook", icon: IMG.FB },
    { id: 5, name: "instagram", icon: IMG.INSF },
  ];

  return (
    <div>
      <div className="bg-light h-full xl:px-30 lg:px-15 md:px-20 px-8 py-12 font-poppins w-full flex justify-center items-center">
        {/* <div className=" w-full h-full"> */}
        <div className="w-full h-full  max-w-screen-2xl">
          <div>
            <div
              // ref={mapInViewRef}
              // initial="hidden"
              // animate={inView ? "visible" : "hidden"}
              // variants={mapAnimation2}
              className="w-full tracking-wider h-auto lg:flex  items-center justify-between"
            >
              <div className="w-auto h-auto lg:mb-0 mb-6 lg:flex-none flex flex-col items-center lg:items-start justify-between">
                <img
                  src={LOGO.BLACK}
                  alt="black logo"
                  className="lg:h-13 h-8"
                />
                <p className="hidden md:block xl:text-xl lg:text-[15px] cursor-pointer mt-7 tracking-widest md:text-start text-center">
                  18th Floor, Taqweem Clinic, KIPCO Tower,
                </p>
                <p className="hidden md:block xl:text-xl lg:text-[15px] cursor-pointer tracking-widest md:text-start text-center">
                  Khalid Bin Waleed St, Kuwait City 13149, Kuwait
                </p>


                <p className="block md:hidden xl:text-xl lg:text-[15px] cursor-pointer mt-7 tracking-widest md:text-start text-center">
                  18th Floor, Taqweem Clinic,
                </p>
                <p className="block md:hidden xl:text-xl lg:text-[15px] cursor-pointer tracking-widest md:text-start text-center text-nowrap">
                  KIPCO Tower,Khalid Bin Waleed St,
                </p>
                <p className="block md:hidden xl:text-xl lg:text-[15px] cursor-pointer tracking-widest md:text-start text-center">
                  Kuwait City 13149, Kuwait
                </p>


                <p className="xl:text-xl lg:text-[15px] pt-[7%] tracking-widest hidden lg:block ">
                  &copy; 2024 All Rights Reserved. Grow Clinic Dental Center
                  Dubai
                </p>
              </div>
              {/* <div className="bg-[#CCE9E9] block lg:hidden w-[100px] h-[2px] lg:w-[2px] lg:h-[75px]"></div> */}
              <div className="flex items-center justify-center lg:hidden">
                <hr className="text-[#CCE9E9] w-[200px] h-[4px] py-[4%] md:py-[2%]" />
              </div>
              <div className="w-auto h-auto flex flex-col items-center justify-center lg:items-end">
                <div className="flex flex-col lg:flex-row items-center lg:justify-end gap-3 ">
                  <img
                    src={IMG.MAIL}
                    alt="mail"
                    className="lg:w-8 w-6  cursor-pointer"
                  />
                  <p className="xl:text-xl lg:text-[15px] tracking-widest  cursor-pointer">
                    support@grow.com
                  </p>
                </div>
                <div className="flex flex-col lg:flex-row  items-center lg:justify-end gap-3 lg:pt-8 pt-2">
                  <img
                    src={IMG.MOB}
                    alt="phone"
                    className="lg:w-6 w-5 cursor-pointer"
                  />
                  <div className="lg:block hidden">
                    <p className="xl:text-xl lg:text-[15px] tracking-widest cursor-pointer">
                      +971 4444 8888
                    </p>
                    <p className="xl:text-xl lg:text-[15px] tracking-widest cursor-pointer">
                      +971 8877 6655
                    </p>
                  </div>
                  <div className="lg:hidden flex">
                    <p className="xl:text-xl lg:text-[15px] tracking-widest cursor-pointer">
                      +971 4444 8888,
                    </p>
                    <p className="xl:text-xl lg:text-[15px] tracking-widest cursor-pointer">
                      +971 8877 6655
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-center lg:hidden pt-[6%] md:pt-[4%]">
                  <hr className="text-[#CCE9E9] w-[200px] h-[4px] py-[4%]" />
                </div>
                <div
                  // initial="hidden"
                  // animate={isVisible ? "visible" : "hidden"}
                  // variants={textAnimation}
                  // transition={{ duration: 0.8 }}
                  // ref={ref}
                  className="flex lg:justify-end items-center gap-10 md:gap-10 lg:mt-10 my-6"
                >
                  {social.map((data) => (
                    <img
                      key={data.id}
                      src={data.icon}
                      alt={data.name}
                      className="lg:h-7 h-6 cursor-pointer"
                    />
                  ))}
                </div>
                <p className="lg:text-lg lg:pt-[7%] tracking-widest hidden md:block lg:hidden md:text-start text-center mt-[6%] md:mt-[2%] ">
                  &copy; 2024 All Rights Reserved.
                  Grow Clinic Dental Center
                  Dubai
                </p>
                <p className="lg:text-lg lg:pt-[7%] tracking-widest md:hidden md:text-start text-center mt-[6%] md:mt-[2%] ">
                  &copy; 2024 All Rights Reserved.<br />
                  Grow Clinic Dental Center
                  Dubai
                </p>

              </div>
            </div>

            {/* animation here  */}
          </div>
        </div>
      </div>
      {/* <div className='bg-white h-full flex justify-center items-center px-5 py-5'>
        <div className='max-w-screen-2xl w-full h-full'>
          <p className='text-2xl text-center'>&copy; 2024 ALL RIGHTS RESERVED. GROW CLINIC DENTAL CENTER DUBAI</p>
        </div>
      </div> */}
    </div>
  );
}

{
  /* ANIMATION */
}

{
  /* <div class="process-scetion bg-prple w-full bg-re">
            <div class="container bg-gren">
              <div class="social-icons bg-he=ro flex items-center justify-center mt-20">
                <a href="https://www.linkedin.com/" target="blank" class="slider-nav-item flex items-center justify-center">
                  <img src={IMG.IN} alt="LinkedIn" className='w-[65%] object-fill' />
                </a>
                <a href="https://www.twitter.com/" target="blank" class="slider-nav-item flex items-center justify-center bg-yellow">
                  <img src={IMG.TW} alt="Twitter" className='w-[80%]' />
                </a>
                <a href="https://www.youtube.com/" target="blank" class="slider-nav-item flex items-center justify-center">
                  <img src={IMG.YT} alt="YouTube" className='w-[60%]' />
                </a>
                <a href="https://www.facebook.com/" target="blank" class="slider-nav-item flex items-center justify-center">
                  <img src={IMG.FB} alt="Facebook" className='w-[40%]' />
                </a>
              </div>
            </div>
          </div> */
}
